import SingleDesignHero from './SingleDesignHero'

export default SingleDesignHero
